import { useState } from "react";

const useHazardActions = ({ onRefresh }) => {
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingHazard, setEditingHazard] = useState(null);
  const [resolveModalVisible, setResolveModalVisible] = useState(false);
  const [resolveHazard, setResolveHazard] = useState(null);
  const [escalateModalVisible, setEscalateModalVisible] = useState(false);
  const [escalateHazard, setEscalateHazard] = useState(null);
  const [reopenModalVisible, setReopenModalVisible] = useState(false);
  const [reopenHazard, setReopenHazard] = useState(null);
  const [confirmResolutionModalVisible, setConfirmResolutionModalVisible] = useState(false);
  const [confirmResolutionHazard, setConfirmResolutionHazard] = useState(null);

  const handleEditClick = (hazard) => {
    setEditingHazard(hazard);
    setEditModalVisible(true);
  };

  const handleEditClose = () => {
    setEditModalVisible(false);
    setEditingHazard(null);
  };

  const handleResolveClick = (hazard) => {
    setResolveHazard(hazard);
    setResolveModalVisible(true);
  };

  const handleResolveClose = () => {
    setResolveModalVisible(false);
    setResolveHazard(null);
  };

  const handleResolveSuccess = () => {
    setResolveModalVisible(false);
    setResolveHazard(null);
    onRefresh();
  };

  const handleEscalateClick = (hazard) => {
    setEscalateHazard(hazard);
    setEscalateModalVisible(true);
  };

  const handleEscalateClose = () => {
    setEscalateModalVisible(false);
    setEscalateHazard(null);
  };

  const handleEscalateSuccess = () => {
    setEscalateModalVisible(false);
    setEscalateHazard(null);
    onRefresh();
  };

  const handleReopenClick = (hazard) => {
    setReopenHazard(hazard);
    setReopenModalVisible(true);
  };

  const handleReopenClose = () => {
    setReopenModalVisible(false);
    setReopenHazard(null);
  };

  const handleReopenSuccess = () => {
    setReopenModalVisible(false);
    setReopenHazard(null);
    onRefresh();
  };

  const handleConfirmResolutionClick = (hazard) => {
    setConfirmResolutionHazard(hazard);
    setConfirmResolutionModalVisible(true);
  };

  const handleConfirmResolutionClose = () => {
    setConfirmResolutionModalVisible(false);
    setConfirmResolutionHazard(null);
  };

  const handleConfirmResolutionSuccess = () => {
    setConfirmResolutionModalVisible(false);
    setConfirmResolutionHazard(null);
    onRefresh();
  };

  return {
    // State
    editModalVisible,
    editingHazard,
    resolveModalVisible,
    resolveHazard,
    escalateModalVisible,
    escalateHazard,
    reopenModalVisible,
    reopenHazard,
    confirmResolutionModalVisible,
    confirmResolutionHazard,

    // Handlers
    handleEditClick,
    handleEditClose,
    handleResolveClick,
    handleResolveClose,
    handleResolveSuccess,
    handleEscalateClick,
    handleEscalateClose,
    handleEscalateSuccess,
    handleReopenClick,
    handleReopenClose,
    handleReopenSuccess,
    handleConfirmResolutionClick,
    handleConfirmResolutionClose,
    handleConfirmResolutionSuccess,
  };
};

export default useHazardActions;
